//export const OPEN_SNACKBAR = "OPEN_SNACKBAR";

export const MOBILE = "mobile";
export const WORKPLACE = "workplace";
export const STORAGE = "storage";
export const SHOW = "SHOW";

export const ORDER = "order";
export const COLLI = "colli";
export const TRANSPORT_COLLI = "transportColli";
export const CUSTOM = "custom";
export const SHOW_COLLECTION = "SHOW_COLLECTION";
export const HIDE_COLLECTION = "HIDE_COLLECTION";

export const INCREMENT_SNACKBAR_COUNTER = "INCREMENT_SNACKBAR_COUNTER";
export const RESET_SNACKBAR_COUNTER = "RESET_SNACKBAR_COUNTER";
export const CLOSE_SNACKBAR = "CLOSE_SNACKBAR";